export default __webpack_public_path__ + "static/logo-2aa0bb96c993554e727c47b29c91f58d.svg";